import { EducationCosts, NormalizedStudentProfile, PolicyConfig } from "./types";

function roundToTwo(value: number): number {
  return Math.round(value * 100) / 100;
}


export function estimateEducationCosts(
  profile: NormalizedStudentProfile,
  policy: PolicyConfig
): EducationCosts {
  const { study, dependants, derived } = profile;

  const tuition = study.tuition;
  const booksSupplies = study.booksSupplies;

  const weeklyAllowance = policy.weeklyLivingAllowance[study.livingArrangement];
  const osapLivingAllowance = weeklyAllowance * study.studyWeeks;

  let livingAllowance: number;

  if (
    study.livingArrangement === "with_parents" ||
    study.livingArrangement === "on_campus"
  ) {
    livingAllowance = osapLivingAllowance;
  } else {
    // Off-campus: use actual rent if provided, otherwise OSAP table
    if (study.actualMonthlyRent !== undefined && study.actualMonthlyRent > 0) {
      const actualAnnualRent = study.actualMonthlyRent * derived.studyMonths;
      // Using the higher of actual vs. OSAP table
      livingAllowance = Math.max(actualAnnualRent, osapLivingAllowance);
    } else {
      livingAllowance = osapLivingAllowance;
    }
  }

  // Child care 
  const childCare = dependants.hasDependants ? dependants.childCareCosts : 0;

  const totalCosts = tuition + booksSupplies + livingAllowance + childCare;

  return {
    tuition: roundToTwo(tuition),
    booksSupplies: roundToTwo(booksSupplies),
    livingAllowance: roundToTwo(livingAllowance),
    childCare: roundToTwo(childCare),
    totalCosts: roundToTwo(totalCosts),
  };
}